import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, useAttrs } from 'vue';

/**
 * アイコンを描画する際に利用できるタグ名。
 */
type IconTag = keyof HTMLElementTagNameMap;

/**
 * サポートするMaterial Iconsのバリアント。
 */
type IconVariant = 'filled' | 'outlined' | 'round';


export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'Mdi',
  props: {
    icon: {},
    tag: { default: 'span' as IconTag },
    variant: { default: 'filled' as IconVariant },
    ariaLabel: { default: '' }
  },
  setup(__props: any) {

const props = __props;



const attrs = useAttrs();

const variantClasses = computed(() => {
  switch (props.variant) {
    case 'outlined':
      return ['material-icons', 'material-icons-outlined'];
    case 'round':
      return ['material-icons', 'material-icons-round'];
    default:
      return ['material-icons'];
  }
});

const iconText = computed(() => props.icon.trim());

const mergedAttrs = computed(() => {
  const recordAttrs = attrs as Record<string, unknown>;
  const { class: classAttr, ...rest } = recordAttrs;
  const attrLabel = typeof recordAttrs['aria-label'] === 'string' ? recordAttrs['aria-label'].trim() : '';
  const hasExternalLabel = attrLabel.length > 0;

  const baseA11y = props.ariaLabel
    ? { role: 'img', 'aria-label': props.ariaLabel }
    : hasExternalLabel
    ? { role: 'img' }
    : { 'aria-hidden': 'true', role: 'presentation' };

  const additionalClass = Array.isArray(classAttr)
    ? classAttr
    : typeof classAttr === 'string' && classAttr.trim().length > 0
    ? classAttr.split(/\s+/).filter(Boolean)
    : [];

  const finalClass = [...variantClasses.value, ...additionalClass];

  return {
    ...baseA11y,
    ...rest,
    ...(props.ariaLabel ? { 'aria-label': props.ariaLabel } : {}),
    class: finalClass.length === 0 ? undefined : finalClass,
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), _normalizeProps(_guardReactiveProps(mergedAttrs.value)), {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(iconText.value), 1)
    ], undefined, true),
    _: 1
  }, 16))
}
}

})